module.exports = "<!--\r\nAdd your custom code here.\r\nThis file and any changes you make to it are preserved every time the app is generated.\r\n-->"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/landing-page/bottomSection.html
// module id = ../../../../../src/app/modules/application/landing-page/bottomSection.html
// module chunks = main